import React from "react";

export const TermsConditions = () => {
    return (
        <div id="terms-conditions">
            <div className="container">
                <div className="section-title">
                    <h2>Terms & Conditions</h2>
                    <p>Last updated on: <b>December 1, 2025</b></p>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <h3>Overview</h3>
                        <p>Welcome to <b>Akriv Tech</b>. We are software development organization providing customized software solutions, system integrations, and related technology services.
                            By accessing our website and/or using our services, you agree to comply with and be bound by these <b>Terms & Conditions</b>. Please read them carefully. If you do not agree to these Terms, you must not access or use our website or services.
                        </p>
                        <h3>Terms</h3>
                        <p>
                            By using our website or services, you represent that you are at least the age of majority in your jurisdiction and have the legal capacity to enter into a binding agreement.
                            You agree not to use our services for any unlawful or unauthorized purpose and to comply with all applicable laws, regulations, and industry standards.
                        </p>
                        <h3>Conditions</h3>
                        <p>
                            We reserve the right to refuse service to anyone for any reason at any time.
                            You understand that information transmitted through our website or services may be transferred over various networks and may be subject to technical limitations.
                            You agree not to reproduce, duplicate, copy, sell, resell, or exploit any portion of our services without our prior written consent.
                        </p>
                        <h3>Personal Data Protection</h3>
                        <p>
                            We take reasonable and appropriate measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
                            We follow generally accepted industry practices to safeguard personal data during transmission and storage.
                            However, no method of transmission over the Internet or electronic storage is completely secure, and we cannot guarantee absolute security.
                        </p>
                        <p>
                            Our services are not directed toward individuals under the age of 18, and we do not knowingly collect personal information from minors.
                            In the event of a merger, acquisition, restructuring, or sale of assets, your personal information may be transferred as part of that transaction, subject to applicable data protection laws.
                        </p>
                        <h3>Information Accuracy and Reliability</h3>
                        <p>
                            While we strive to ensure that the information on our website is accurate and up to date, we do not warrant that any content is complete, accurate, or current.
                            Any reliance on information provided through our website or services is at your own risk.
                        </p>
                        <h3>Service and Pricing Changes</h3>
                        <p>
                            We reserve the right to modify, suspend, or discontinue any part of our services at any time without prior notice.
                            Prices for services may change without notice. We shall not be liable for any modification, suspension, or discontinuation of services.
                        </p>
                        <h3>Disclaimers and Warranties</h3>
                        <p>
                            We provide our services using commercially reasonable skill and care.
                            However, all services are provided on an “as is” and “as available” basis. We disclaim all warranties, express or implied, including but not limited to implied warranties of merchantability, fitness for a particular purpose, and non-infringement.
                            We do not guarantee uninterrupted, error-free, or secure operation of our services.
                        </p>
                        <h3>Payment Terms</h3>
                        <p>
                            You agree to provide accurate, complete, and up-to-date billing and contact information.
                            Failure to do so may result in delays, suspension, or termination of services.
                            Payment terms and conditions will be governed by the applicable project agreement.
                        </p>
                        <h3>Tools and Links</h3>
                        <p>
                            Our website or services may include links to third-party tools or websites that we do not control.
                            We are not responsible for the content, policies, or practices of any third-party services.
                            Your use of third-party tools is at your own risk.
                        </p>
                        <h3>Corrections</h3>
                        <p>
                            Occasionally, information on our website may contain typographical errors, inaccuracies, or omissions.
                            We reserve the right to correct such errors at any time without prior notice.
                        </p>
                        <h3>Prohibited Uses</h3>
                        <p>
                            You are prohibited from using our website or services for unlawful purposes, to violate applicable laws, infringe intellectual property rights, transmit malicious code, or interfere with system security.
                            We reserve the right to terminate access for violations of this section.
                        </p>
                        <h3>Termination</h3>
                        <p>
                            These Terms remain effective unless terminated by either party.
                            We may terminate or suspend access to our services immediately if you violate any provision of these Terms.
                        </p>
                        <h3>Governing Law</h3>
                        <p>
                            These terms and conditions are governed by and construed in
                            accordance with the laws of India and you irrevocably submit to
                            the exclusive jurisdiction of the courts located in India.
                        </p>
                        <h3>Amendments</h3>
                        <p>
                            We reserve the right to update or modify these Terms at any time.
                            Any changes will be effective upon posting on our website.
                            Continued use of our services constitutes acceptance of the updated Terms.
                        </p>
                        <h3>Questions</h3>
                        <p>
                            If you have any questions regarding these Terms & Conditions,
                            please contact us at <b>contact@akrivtech.com</b>.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
